const now = new Date();

export const handleCurrentDate = () => {
  let month = now.getMonth() + 1;
  let day = now.getDate();
  const year = now.getFullYear();

  if (String(month).length === 1) {
    month = `0${month}`;
  }
  if (String(day).length === 1) {
    day = `0${day}`;
  }

  const months = {
    "01": "January",
    "02": "February",
    "03": "March",
    "04": "April",
    "05": "May",
    "06": "June",
    "07": "July",
    "08": "August",
    "09": "September",
    "10": "October",
    "11": "November",
    "12": "December",
  };

  const finalDate = {
   display: `${month}.${day}.${year}`,
   alt: `${months[month]} ${day}, ${year}`,
   file: `${month}_${day}_${year}`,
  };

  return finalDate;
};

export const handleCurrentTime = () => {
  let hours = now.getHours();
  let minutes = now.getMinutes();

  const ampm = hours >= 12 ? "PM" : "AM";

  // convert hour from 24-hr format to 12-hr format
  hours %= 12;

  if (hours === 0) {
    hours = 12;
  }

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  const finalTime = {
    display: `${hours}:${minutes} ${ampm}`,
    alt: `${hours}:${minutes} ${ampm}`,
    file: `${hours}_${minutes}_${ampm}`
  };

  return finalTime;
};
